<template>
  <div class="createOrEditRoot">
    <div class="resourceFormPage divContainer configModule">
      <div v-if="loading" v-loading="loading" class="fullContainer" />
      <div v-else class="resourceFormPage__layout">
        <el-form
          ref="ruleForm"
          label-position="top"
          size="small"
          class="resourceFormPage__form"
          :model="ruleForm"
          :rules="rules"
          hide-required-asterisk
          @submit.native.prevent
        >
          <div class="resourceFormPage__headerDock">
            <header class="resourceFormPage__actionBar">
              <div class="resourceFormPage__lead">
                <h1 class="resourceFormPage__pageTitle">
                  {{ isCreate ? '新建 AI Style' : '编辑 AI Style' }}
                </h1>
                <span v-if="typeLabel" class="resourceFormPage__typeReadonly">
                  {{ typeLabel }}
                </span>
              </div>
              <div class="resourceFormPage__actions">
                <button
                  type="button"
                  class="resourceFormPage__btn resourceFormPage__btn--ghost"
                  @click="goBack"
                >
                  取消
                </button>
                <button
                  type="button"
                  class="resourceFormPage__btn resourceFormPage__btn--primary"
                  :disabled="buttonLoading"
                  @click="submitForm"
                >
                  {{ buttonLoading ? '保存中…' : '保存' }}
                </button>
              </div>
            </header>
          </div>

          <main class="resourceFormPage__main main configFormPage__main">
            <!-- 基本信息：对齐 AI 角色 / 通用资源 — 左封面锚点 + 右字段 -->
            <el-card class="card linkFormSection configFormPage__section" data-section-id="basic">
              <div slot="header" class="linkFormSection__header">
                <strong class="linkFormSection__title">基本信息</strong>
              </div>

              <div class="linkFormBasic">
                <div class="linkFormBasic__media">
                  <div class="linkFormMediaAnchor" v-loading="previewLoading">
                    <el-image
                      v-if="ruleForm.stylePreview"
                      class="linkFormMediaAnchor__preview"
                      :src="ruleForm.stylePreview"
                      :preview-src-list="[ruleForm.stylePreview]"
                      fit="cover"
                    >
                      <div slot="error" class="linkFormMediaAnchor__previewFallback">
                        <i class="el-icon-picture-outline" aria-hidden="true" />
                      </div>
                    </el-image>
                    <button
                      v-else
                      type="button"
                      class="linkFormUploadZone linkFormUploadZone--anchor"
                      :disabled="previewLoading"
                      @click="triggerPreviewUpload"
                    >
                      <i class="el-icon-upload2 linkFormUploadZone__icon" aria-hidden="true" />
                      <span>上传封面图</span>
                      <span class="linkFormUploadZone__hint">风格预览封面</span>
                    </button>
                  </div>

                  <div v-if="ruleForm.stylePreview" class="linkFormMediaFileBar">
                    <span class="linkFormMediaFileBar__name">封面图</span>
                    <div class="linkFormMediaFileBar__actions">
                      <button
                        type="button"
                        class="linkFormMediaFileBar__btn"
                        :disabled="previewLoading"
                        @click="triggerPreviewUpload"
                      >
                        替换
                      </button>
                      <button
                        type="button"
                        class="linkFormMediaFileBar__btn linkFormMediaFileBar__btn--danger"
                        @click="clearPreview"
                      >
                        移除
                      </button>
                    </div>
                  </div>

                  <el-upload
                    ref="previewUpload"
                    class="configFormPage__hiddenUpload"
                    action="/"
                    accept="image/*"
                    :http-request="(params) => customRequest(params, 'stylePreview')"
                    :show-file-list="false"
                  />
                </div>

                <div class="linkFormBasic__fields configFormPage__fields">
                  <el-form-item label="AppKey" prop="appKey">
                    <el-input v-model="ruleForm.appKey" placeholder="请输入 AppKey" clearable />
                  </el-form-item>
                  <el-form-item label="分类" prop="type">
                    <el-select v-model="ruleForm.type" placeholder="请选择分类" clearable>
                      <el-option label="文生图" value="1" />
                      <el-option label="图生图" value="2" />
                      <el-option label="角色文生图" value="3" />
                      <el-option label="角色图生图" value="4" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="风格（英文）" prop="style">
                    <el-input v-model="ruleForm.style" placeholder="英文名称" clearable />
                  </el-form-item>
                  <el-form-item label="风格（中文）" prop="styleDescription">
                    <el-input
                      v-model="ruleForm.styleDescription"
                      placeholder="中文名称"
                      clearable
                    />
                  </el-form-item>
                  <el-form-item label="界面类型" prop="group">
                    <el-select v-model="ruleForm.group" placeholder="请选择" clearable>
                      <el-option label="文生图" value="0" />
                      <el-option label="gender role" value="1" />
                      <el-option label="specified style" value="2" />
                      <el-option label="custom style" value="3" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="状态" prop="status">
                    <el-select v-model.number="ruleForm.status" placeholder="请选择">
                      <el-option label="下线" :value="0" />
                      <el-option label="上线" :value="1" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="排序" prop="sort">
                    <el-input
                      v-model.number="ruleForm.sort"
                      type="number"
                      placeholder="排序值"
                    />
                  </el-form-item>
                  <el-form-item label="version-limit" prop="versionLimit">
                    <el-input
                      v-model.number="ruleForm.versionLimit"
                      type="number"
                      placeholder="版本限制"
                    />
                  </el-form-item>
                  <el-form-item label="category" prop="category">
                    <el-input v-model="ruleForm.category" placeholder="category" clearable />
                  </el-form-item>
                  <div class="configFormPage__switchRow">
                    <el-form-item label="是否新增" prop="isNew">
                      <el-radio-group v-model.number="ruleForm.isNew">
                        <el-radio :label="0">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否使用人脸" prop="isFaceRecognition">
                      <el-radio-group v-model.number="ruleForm.isFaceRecognition">
                        <el-radio :label="0">不需要</el-radio>
                        <el-radio :label="1">需要</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="加锁方式" prop="lockingMethod">
                      <el-radio-group v-model.number="ruleForm.lockingMethod">
                        <el-radio :label="0">0</el-radio>
                        <el-radio :label="1">1</el-radio>
                        <el-radio :label="2">2</el-radio>
                        <el-radio :label="3">3</el-radio>
                        <el-radio :label="4">4</el-radio>
                        <el-radio :label="5">5</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </el-card>

            <el-card class="card linkFormSection configFormPage__section" data-section-id="media">
              <div slot="header" class="linkFormSection__header">
                <strong class="linkFormSection__title">对比素材</strong>
                <span class="configFormPage__sectionHint">原图与 AI 效果图并排对比</span>
              </div>

              <div class="configFormPage__compare">
                <div class="configFormPage__comparePanel" v-loading="originLoading">
                  <div class="configFormPage__compareHead">
                    <span class="configFormPage__compareTitle">原始图片</span>
                    <span class="configFormPage__compareBadge">Before</span>
                  </div>
                  <div
                    class="configFormPage__compareFrame"
                    :class="{ 'configFormPage__compareFrame--filled': ruleForm.contentUrl.origin }"
                  >
                    <el-image
                      v-if="ruleForm.contentUrl.origin"
                      :src="ruleForm.contentUrl.origin"
                      :preview-src-list="[ruleForm.contentUrl.origin]"
                      fit="contain"
                    />
                    <div v-else class="configFormPage__compareEmpty">
                      <i class="el-icon-picture-outline" />
                      <span>上传用户侧原图</span>
                    </div>
                  </div>
                  <div class="configFormPage__compareActions">
                    <button
                      type="button"
                      class="configFormPage__compareBtn"
                      @click="triggerMediaUpload('origin')"
                    >
                      {{ ruleForm.contentUrl.origin ? '替换' : '上传' }}
                    </button>
                    <button
                      v-if="ruleForm.contentUrl.origin"
                      type="button"
                      class="configFormPage__compareBtn configFormPage__compareBtn--danger"
                      @click="clearMedia('origin')"
                    >
                      移除
                    </button>
                  </div>
                </div>

                <div class="configFormPage__compareArrow" aria-hidden="true">
                  <i class="el-icon-right" />
                </div>

                <div class="configFormPage__comparePanel" v-loading="alteredLoading">
                  <div class="configFormPage__compareHead">
                    <span class="configFormPage__compareTitle">AI 后的图</span>
                    <span class="configFormPage__compareBadge">After</span>
                  </div>
                  <div
                    class="configFormPage__compareFrame"
                    :class="{ 'configFormPage__compareFrame--filled': ruleForm.contentUrl.altered }"
                  >
                    <el-image
                      v-if="ruleForm.contentUrl.altered"
                      :src="ruleForm.contentUrl.altered"
                      :preview-src-list="[ruleForm.contentUrl.altered]"
                      fit="contain"
                    />
                    <div v-else class="configFormPage__compareEmpty">
                      <i class="el-icon-magic-stick" />
                      <span>上传 AI 生成效果图</span>
                    </div>
                  </div>
                  <div class="configFormPage__compareActions">
                    <button
                      type="button"
                      class="configFormPage__compareBtn"
                      @click="triggerMediaUpload('altered')"
                    >
                      {{ ruleForm.contentUrl.altered ? '替换' : '上传' }}
                    </button>
                    <button
                      v-if="ruleForm.contentUrl.altered"
                      type="button"
                      class="configFormPage__compareBtn configFormPage__compareBtn--danger"
                      @click="clearMedia('altered')"
                    >
                      移除
                    </button>
                  </div>
                </div>
              </div>

              <el-upload
                ref="originUpload"
                class="configFormPage__hiddenUpload"
                action="/"
                accept="image/*"
                :http-request="(params) => customRequest(params, 'origin')"
                :show-file-list="false"
              />
              <el-upload
                ref="alteredUpload"
                class="configFormPage__hiddenUpload"
                action="/"
                accept="image/*"
                :http-request="(params) => customRequest(params, 'altered')"
                :show-file-list="false"
              />
            </el-card>

            <el-card class="card linkFormSection configFormPage__section" data-section-id="json">
              <div slot="header" class="linkFormSection__header">
                <strong class="linkFormSection__title">配置 JSON</strong>
              </div>

              <div class="configFormPage__jsonShell">
                <div class="configFormPage__jsonTabs" role="tablist">
                  <button
                    v-for="tab in jsonTabs"
                    :key="tab.key"
                    type="button"
                    class="configFormPage__jsonTab"
                    :class="{ 'is-active': activeJsonTab === tab.key }"
                    role="tab"
                    :aria-selected="activeJsonTab === tab.key ? 'true' : 'false'"
                    @click="activeJsonTab = tab.key"
                  >
                    {{ tab.label }}
                  </button>
                </div>

                <div class="configFormPage__jsonEditor">
                  <div class="configFormPage__jsonEditorHead">
                    <div>
                      <div class="configFormPage__jsonEditorTitle">{{ activeJsonMeta.title }}</div>
                      <div class="configFormPage__jsonEditorHint">{{ activeJsonMeta.hint }}</div>
                    </div>
                    <el-button
                      v-if="activeJsonTab === 'workflow'"
                      size="small"
                      plain
                      icon="el-icon-download"
                      @click="downloadJson"
                    >
                      下载
                    </el-button>
                  </div>
                  <el-form-item :prop="activeJsonMeta.prop" class="configFormPage__field--wide">
                    <el-input
                      v-model="ruleForm[activeJsonMeta.prop]"
                      type="textarea"
                      class="configFormPage__jsonTextarea"
                      :autosize="{ minRows: 14, maxRows: 20 }"
                      :placeholder="activeJsonMeta.placeholder"
                    />
                  </el-form-item>
                </div>
              </div>
            </el-card>
          </main>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  updateAiStyleById,
  getAiStyleById,
  createAiStyle,
} from '../../../api/aiStyle'
import { uploadFile } from '../../../api/comment'

const TYPE_LABELS = {
  '1': '文生图',
  '2': '图生图',
  '3': '角色文生图',
  '4': '角色图生图',
}

function createEmptyRuleForm() {
  return {
    workflow: '{}',
    paramConfig: '{}',
    languageJson: '[]',
    appKey: '',
    versionLimit: null,
    status: 1,
    style: '',
    styleDescription: '',
    stylePreview: '',
    type: '',
    sort: '',
    group: '',
    isFaceRecognition: 0,
    lockingMethod: 0,
    isNew: 0,
    contentUrl: {
      origin: '',
      altered: '',
    },
    category: '',
  }
}

export default {
  name: 'AiStyleCreateOrEdit',
  data() {
    return {
      isCreate: true,
      ruleForm: createEmptyRuleForm(),
      loading: false,
      buttonLoading: false,
      rules: {},
      previewLoading: false,
      originLoading: false,
      alteredLoading: false,
      activeJsonTab: 'workflow',
      jsonTabs: [
        {
          key: 'workflow',
          label: 'Workflow',
          prop: 'workflow',
          title: 'workflow json',
          hint: 'ComfyUI / 工作流定义',
          placeholder: '请输入 workflow JSON',
        },
        {
          key: 'paramConfig',
          label: 'ParamConfig',
          prop: 'paramConfig',
          title: 'paramConfig json',
          hint: '运行时参数映射',
          placeholder: '请输入 paramConfig JSON',
        },
        {
          key: 'languageJson',
          label: 'Language',
          prop: 'languageJson',
          title: 'language json',
          hint: '多语言文案配置',
          placeholder: '请输入 language JSON 数组',
        },
      ],
    }
  },
  computed: {
    typeLabel() {
      return TYPE_LABELS[String(this.ruleForm.type)] || ''
    },
    activeJsonMeta() {
      return (
        this.jsonTabs.find((tab) => tab.key === this.activeJsonTab) || this.jsonTabs[0]
      )
    },
  },
  created() {
    this.isCreate = this.$route.path.indexOf('edit') === -1
    if (!this.isCreate) {
      this.getData()
    }
  },
  methods: {
    triggerPreviewUpload() {
      const upload = this.$refs.previewUpload
      if (upload && upload.$refs['upload-inner'] && upload.$refs['upload-inner'].$refs.input) {
        upload.$refs['upload-inner'].$refs.input.click()
      }
    },
    clearPreview() {
      this.ruleForm.stylePreview = ''
    },
    triggerMediaUpload(type) {
      const refName = type === 'origin' ? 'originUpload' : 'alteredUpload'
      const upload = this.$refs[refName]
      if (upload && upload.$refs['upload-inner'] && upload.$refs['upload-inner'].$refs.input) {
        upload.$refs['upload-inner'].$refs.input.click()
      }
    },
    clearMedia(type) {
      if (!this.ruleForm.contentUrl) {
        this.$set(this.ruleForm, 'contentUrl', { origin: '', altered: '' })
      }
      this.ruleForm.contentUrl[type] = ''
    },
    customRequest(params, type) {
      if (type === 'stylePreview') {
        this.previewLoading = true
      } else if (type === 'origin') {
        this.originLoading = true
      } else if (type === 'altered') {
        this.alteredLoading = true
      }
      const file = new FormData()
      file.append('file', params.file)
      uploadFile(file)
        .then((res) => {
          if (res.success) {
            if (type === 'stylePreview') {
              this.ruleForm.stylePreview = res.data
            } else if (type === 'origin') {
              if (!this.ruleForm.contentUrl) {
                this.$set(this.ruleForm, 'contentUrl', { origin: '', altered: '' })
              }
              this.ruleForm.contentUrl.origin = res.data
            } else if (type === 'altered') {
              if (!this.ruleForm.contentUrl) {
                this.$set(this.ruleForm, 'contentUrl', { origin: '', altered: '' })
              }
              this.ruleForm.contentUrl.altered = res.data
            }
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
        .finally(() => {
          if (type === 'stylePreview') {
            this.previewLoading = false
          } else if (type === 'origin') {
            this.originLoading = false
          } else if (type === 'altered') {
            this.alteredLoading = false
          }
        })
      return false
    },
    getData() {
      this.loading = true
      getAiStyleById({ id: this.$route.params.id })
        .then((res) => {
          if (res.success) {
            const data = res.data || {}
            if (!data.contentUrl) {
              data.contentUrl = { origin: '', altered: '' }
            }
            this.ruleForm = data
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.$message.error('你还有参数没有填完整')
          return false
        }
        this.buttonLoading = true
        const request = this.isCreate
          ? createAiStyle(this.ruleForm)
          : updateAiStyleById(this.ruleForm)
        request
          .then((res) => {
            if (res.success) {
              this.$message.success(this.isCreate ? '新增成功!' : '编辑成功!')
              this.$router.push('/config/aiStyle/list')
            }
          })
          .catch((err) => {
            this.$message.error(err)
          })
          .finally(() => {
            this.buttonLoading = false
          })
      })
    },
    goBack() {
      this.$router.push('/config/aiStyle/list')
    },
    downloadJson() {
      try {
        let data = this.ruleForm.workflow
        if (typeof data === 'string') {
          data = JSON.parse(data)
        }
        const jsonStr = JSON.stringify(data, null, 2)
        const blob = new Blob([jsonStr], { type: 'application/json' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `workflow-${new Date().getTime()}.json`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } catch (error) {
        console.error('下载JSON失败:', error)
        this.$message.error('下载失败，请重试')
      }
    },
  },
}
</script>

<style scoped>
.createOrEditRoot,
.fullContainer {
  height: 100%;
}

.resourceFormPage__form {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
</style>

<style>
.configModule.divContainer {
  min-height: 100%;
  background: var(--link-canvas);
}

.configModule .main {
  background: transparent;
}
</style>
